import AceEditor from 'react-ace';
import 'brace/mode/html';
import 'brace/theme/github';

export default AceEditor;
